module.exports = __webpack_public_path__ + "img/pikachu-min.3ffc809e.png";